import { Card, Typography, Box } from '@mui/material'
import { alpha, styled } from '@mui/material/styles'
import { CardCustomProps } from './type'
import React from 'react'
import palette from '../../themes/styles/palette'
const StyledIcon = styled('div')(({ theme }) => ({
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
}))

const CardCustom: React.FC<CardCustomProps> = ({
  total,
  title,
  color = 'primary',
  Icon,
  cardProp,
}) => {
  return (
    <React.Fragment>
      <Card
        sx={{
          p: 3,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          color: (theme) => theme.palette[color].darker,
        }}
        {...cardProp}
      >
        <Box>
          <Typography align='center' variant='subtitle1' sx={{ opacity: 0.72, my: 1 }}>
            {title}
          </Typography>
          <Typography align='center' variant='h3'>
            {total ?? 0}
          </Typography>
        </Box>
        <Box>
          <StyledIcon
            sx={{
              color: (theme) => theme.palette[color].dark,
              backgroundImage: (theme) =>
                `linear-gradient(135deg, ${alpha(theme.palette[color].dark, 0)} 0%, ${alpha(
                  theme.palette[color].dark,
                  0.24,
                )} 100%)`,
            }}
          >
            <Icon fill={palette[color]} />
          </StyledIcon>
        </Box>
      </Card>
    </React.Fragment>
  )
}

export default CardCustom
